"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAppProperties = exports.EObjectTypeMappingStatuses = exports.EApplicationObjectTypeGroup = void 0;
var EApplicationObjectTypeGroup;
(function (EApplicationObjectTypeGroup) {
    EApplicationObjectTypeGroup["NONE"] = "NONE";
    EApplicationObjectTypeGroup["ROOM"] = "ROOM";
    EApplicationObjectTypeGroup["PROFESSOR"] = "PROFESSOR";
    EApplicationObjectTypeGroup["COURSE"] = "COURSE";
    EApplicationObjectTypeGroup["COURSE_INFORMATION"] = "COURSE_INFORMATION";
    EApplicationObjectTypeGroup["INVOICING"] = "INVOICING";
    EApplicationObjectTypeGroup["STUDENT_SET"] = "STUDENT_SET";
    EApplicationObjectTypeGroup["STUDENT_SET_GROUP"] = "STUDENT_SET_GROUP";
    EApplicationObjectTypeGroup["PROGRAM"] = "PROGRAM";
    EApplicationObjectTypeGroup["ACTIVITY_TYPE"] = "ACTIVITY_TYPE";
    EApplicationObjectTypeGroup["STUDENT"] = "STUDENT";
    EApplicationObjectTypeGroup["STAFF"] = "STAFF";
    EApplicationObjectTypeGroup["CHANGE_REQUEST"] = "CHANGE_REQUEST";
    EApplicationObjectTypeGroup["INVIGILATOR"] = "INVIGILATOR";
})(EApplicationObjectTypeGroup = exports.EApplicationObjectTypeGroup || (exports.EApplicationObjectTypeGroup = {}));
var EObjectTypeMappingStatuses;
(function (EObjectTypeMappingStatuses) {
    EObjectTypeMappingStatuses["NOT_TESTED"] = "NOT_TESTED";
    EObjectTypeMappingStatuses["NOT_MAPPED"] = "NOT_MAPPED";
    EObjectTypeMappingStatuses["MAPPED"] = "MAPPED";
    EObjectTypeMappingStatuses["TESTED"] = "TESTED";
    EObjectTypeMappingStatuses["FAILED"] = "FAILED";
})(EObjectTypeMappingStatuses = exports.EObjectTypeMappingStatuses || (exports.EObjectTypeMappingStatuses = {}));
var EAppProperties;
(function (EAppProperties) {
    EAppProperties["NONE"] = "NONE";
    EAppProperties["NAME"] = "NAME";
    EAppProperties["LABEL"] = "LABEL";
    EAppProperties["EMAIL"] = "EMAIL";
    EAppProperties["FIRST_NAME"] = "FIRST_NAME";
    EAppProperties["LAST_NAME"] = "LAST_NAME";
    EAppProperties["TITLE"] = "TITLE";
    EAppProperties["ID"] = "ID";
    EAppProperties["STATE"] = "STATE";
    EAppProperties["SEMESTER"] = "SEMESTER";
    EAppProperties["MAX_STUDENTS"] = "MAX_STUDENTS";
    EAppProperties["WAITLIST"] = "WAITLIST";
    EAppProperties["ACTIVITY_TYPE"] = "ACTIVITY_TYPE";
    EAppProperties["START_DATE"] = "START_DATE";
    EAppProperties["END_DATE"] = "END_DATE";
    EAppProperties["ALLOW_REGISTRATION"] = "ALLOW_REGISTRATION";
    EAppProperties["AUTO_ALLOCATION_ACTIVATED"] = "AUTO_ALLOCATION_ACTIVATED";
    EAppProperties["BUFFER"] = "BUFFER";
    EAppProperties["LINKTRACK"] = "LINKTRACK";
    EAppProperties["HIDETRACK"] = "HIDETRACK";
    EAppProperties["DEDICATETRACK"] = "DEDICATETRACK";
    EAppProperties["TRACK"] = "TRACK";
    EAppProperties["SEATS"] = "SEATS";
    EAppProperties["REGISTRATION_PERIOD_SET"] = "REGISTRATION_PERIOD_SET";
    EAppProperties["DISTRIBUTION_RULE"] = "DISTRIBUTION_RULE";
    EAppProperties["COURSE_OCCURENCE"] = "COURSE_OCCURENCE";
    EAppProperties["PLANNED_SIZE"] = "PLANNED_SIZE";
    EAppProperties["PROGRAM"] = "PROGRAM";
    EAppProperties["ROOM_NAME"] = "ROOM_NAME";
    EAppProperties["ROOM_TYPE"] = "ROOM_TYPE";
    EAppProperties["REASONABLE_ADJUSTMENT"] = "REASONABLE_ADJUSTMENT";
})(EAppProperties = exports.EAppProperties || (exports.EAppProperties = {}));
